import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { consumeContext } from "../AppContext";
import Toolbar from "../../Components/RecorderToolbar/Toolbar";
import FramesButton from "../../Components/RecorderToolbar/FramesButton";
import ColorPicker from "../../Components/RecorderToolbar/ColorPicker";
import SizePicker from "../../Components/RecorderToolbar/SizePicker";
import SpeedPicker from "../../Components/RecorderToolbar/SpeedPicker";
import RecordButton from "../../Components/RecorderToolbar/RecordButton";
import HotspotSwitch from "../../Components/RecorderToolbar/HotspotSwitch";
import StopRehearseButton from "../../Components/RecorderToolbar/StopRehearseButton";
import RecordedVideoPan from "../../Components/RecorderToolbar/RecordedVideoPan";
import RecordMobile from "../../Components/RecorderToolbar/RecordMobile";

var ToolbarContainer = function ToolbarContainer(_ref) {
  var AppContext = _ref.AppContext;
  useEffect(function () {
    if (!AppContext.frames.hasFrames()) {
      return;
    }

    var _AppContext$state$fra = AppContext.state.frames.frames,
        frames = _AppContext$state$fra === undefined ? [] : _AppContext$state$fra;

    if (frames.length === 0) {
      AppContext.frames.loadFrames();
    }
  }, []);
  var increaseScriptTextSize = AppContext.increaseScriptTextSize,
      decreaseScriptTextSize = AppContext.decreaseScriptTextSize,
      setTeleprompterSpeed = AppContext.setTeleprompterSpeed,
      setScriptTextColor = AppContext.setScriptTextColor,
      toggleHotspot = AppContext.toggleHotspot,
      toggleFrames = AppContext.toggleFrames,
      startRecording = AppContext.startRecording,
      stopRecording = AppContext.stopRecording,
      stopRehearsing = AppContext.stopRehearsing,
      useRecordedVideo = AppContext.useRecordedVideo,
      resetRecordedVideo = AppContext.resetRecordedVideo;
  var _AppContext$state = AppContext.state,
      mobileRecordSettings = _AppContext$state.mobileRecordSettings,
      teleprompterSpeed = _AppContext$state.teleprompterSpeed,
      scriptTextColor = _AppContext$state.scriptTextColor,
      isRecording = _AppContext$state.isRecording,
      isRehearsing = _AppContext$state.isRehearsing,
      recordedVideo = _AppContext$state.recordedVideo,
      showHotspot = _AppContext$state.showHotspot,
      showFrames = _AppContext$state.showFrames,
      qrCodeData = _AppContext$state.qrCodeData;
  return React.createElement(Toolbar, null, !recordedVideo && React.createElement(React.Fragment, null, AppContext.frames.hasFrames() && React.createElement(FramesButton, {
    toggled: showFrames,
    toggle: toggleFrames
  }), React.createElement(ColorPicker, {
    color: scriptTextColor,
    onChange: setScriptTextColor
  }), React.createElement(SizePicker, {
    increase: increaseScriptTextSize,
    decrease: decreaseScriptTextSize
  }), React.createElement(SpeedPicker, {
    speed: teleprompterSpeed,
    selectSpeed: setTeleprompterSpeed
  }), !isRehearsing && React.createElement(React.Fragment, null, React.createElement(RecordButton, {
    isRecording: isRecording,
    onClick: isRecording ? function () {
      return stopRecording();
    } : startRecording
  }), !recordedVideo && React.createElement(HotspotSwitch, {
    isActive: showHotspot,
    toggle: toggleHotspot
  }), mobileRecordSettings && !isRecording && React.createElement(RecordMobile, {
    mobileRecordSettings: mobileRecordSettings,
    qrCodeData: qrCodeData
  }))), isRehearsing && React.createElement(StopRehearseButton, {
    onClick: stopRehearsing
  }), recordedVideo && React.createElement(RecordedVideoPan, {
    confirm: useRecordedVideo,
    discard: resetRecordedVideo
  }));
};

ToolbarContainer.propTypes = process.env.NODE_ENV !== "production" ? {
  AppContext: PropTypes.object.isRequired
} : {};
export default consumeContext(ToolbarContainer);